<template>
<span class="phone-link" :class="{ dark: dark}">
          <a :href="`mailto:`+emailaddr">
              {{ emailaddr }}
          </a>
     
</span> 
  
</template>

<script>
export default {
  name: 'Email',
  props: {
    emailaddr: String,
    dark: Boolean
  },

  data: () => ({
  }),
};
</script>
<style scoped>

.phone-link.dark a{
  color: #fff;
}
.phone-link a{
  color: #336;
  text-decoration: underline;
}
.phone-link a:hover{

  text-decoration: unset;
}

</style>